import type { EntityState } from '../enums/EntityState'

export class ActivityLogEntity {
  id?: string
  entityId?: string | null
  sessionId?: string | null
  entityName?: string | null
  userId?: string | null
  userDisplayName?: string | null
  state?: EntityState
  metadata?: string | null
  startTime?: string
  endTime?: string
  isSucceeded?: boolean
  errorMessage?: string | null
}
